import { clean } from "@contentful-api/helpers/clean";
import { to } from "@contentful-api/helpers/to";
import { getPagePathByCompleteSlug } from "@contentful-api/queries/pagePath/pagePathService";
import { getSiteSettingsContentType } from "@contentful-api/queries/siteSettings/siteSettingsService";
import type { PagePath } from "@lib/constants/pagePaths";

interface IBasePage {
    locale: string;
    localeTagId: string;
    selectedFields?: string[];
    onlySelected?: boolean;
    textCollection?: string[];
}

interface IPage extends IBasePage {
    slug: string | string[];
    basePath: PagePath;
}

export const getPage = async ({
    slug,
    locale,
    basePath,
    localeTagId,
    selectedFields,
    onlySelected,
    textCollection,
}: IPage) => {
    const [siteSettingsResult, pagePathResult] = await Promise.all([
        to(
            getSiteSettingsContentType({
                locale,
                localeTagId,
                otherFields: selectedFields,
                onlySelected,
                textCollection,
            })
        ),
        to(
            getPagePathByCompleteSlug({
                slug,
                locale,
                basePath,
                localeTagId,
            })
        ),
    ]);

    const { data: siteSettings, error: siteSettingsError } = siteSettingsResult;
    const { data: pagePath, error: pagePathError } = pagePathResult;

    const result = clean({
        siteSettings,
        pagePath,
    });

    return {
        data: result,
        error: siteSettingsError || pagePathError,
    };
};

export const getPageWithoutPath = async ({
    locale,
    localeTagId,
    selectedFields,
    textCollection,
}: IBasePage) => {
    const { data: siteSettings, error: siteSettingsError } = await to(
        getSiteSettingsContentType({
            locale,
            localeTagId,
            otherFields: selectedFields,
            textCollection,
        })
    );

    const result = clean({
        siteSettings,
    });

    return {
        data: result,
        error: siteSettingsError,
    };
};
